import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PrintedBillsComponent from './printed-bills.component';

let PrintedBillsModule = angular
  .module('PrintedBills', [
    uiRouter
  ])
  .component('printedbills', PrintedBillsComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('printedBills', {
      url: '/printed-bills',
      data: {
        authRequired: true,
        permsRequired: ['printed-bills']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'printedbills'
        }
      }
    })
  })
  .name;

export default PrintedBillsModule;



// WEBPACK FOOTER //
// ./src/app/pages/printed-bills/printed-bills.module.js